import { useNavigate } from '@tanstack/react-router';
import { Button, Sticker } from '@/components/ui';
import { useGeolocation, requestCompassPermission } from '@/lib/geo';

export function OnboardingLocationPage() {
  const navigate = useNavigate();
  const geo = useGeolocation(false);

  const enable = async () => {
    await requestCompassPermission();
    const fix = await geo.requestOnce();
    if (fix) void navigate({ to: '/onboarding/profile' });
  };

  const done = geo.permission === 'granted' || !!geo.coords;

  return (
    <div className="flex flex-col gap-6">
      <div>
        <Sticker flavor="grape" rotate={-3}>
          setup · 3 / 4
        </Sticker>
        <h1 className="mt-4 text-3xl font-semibold">Turn on location</h1>
        <p className="mt-2 text-sm text-ink-soft">
          Nearmirer needs it to place you at a venue and show who’s nearby. We use it live and never
          keep a history of where you’ve been.
        </p>
      </div>

      <ul className="space-y-2 text-sm text-ink-soft">
        <li>📍 Used only while the app is open</li>
        <li>🧭 A compass heading (if your phone has one) makes the direction arrow better</li>
        <li>🗑️ Your coordinates are overwritten every few seconds and deleted within hours</li>
      </ul>

      {geo.permission === 'denied' && (
        <p className="text-sm text-critical">
          Location is blocked for this site. Enable it in your browser’s site settings, then reload.
        </p>
      )}

      <div className="flex flex-col gap-2">
        {!done ? (
          <Button variant="candy" size="lg" onClick={enable} disabled={geo.loading}>
            {geo.loading ? 'Waiting for permission…' : 'Allow location'}
          </Button>
        ) : (
          <Button variant="candy" size="lg" onClick={() => navigate({ to: '/onboarding/profile' })}>
            Location on — continue
          </Button>
        )}
        <button
          onClick={() => navigate({ to: '/onboarding/profile' })}
          className="text-xs font-semibold text-ink-faint underline"
        >
          Skip for now
        </button>
      </div>
    </div>
  );
}
